<template>
  <div>
    <el-card>
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane :label="v.PlatformName" :name="v.KOLPlatformId" v-for="(v,i) in tabsList" :key="i"></el-tab-pane>
      </el-tabs>
      <div class="flex flex-column gap-20">
        <div class="flex flex-align-center">
          <div class="font-label font-bold">关键字：</div>
          <el-input v-model="keywords" placeholder="达人名称、达人账号" style="width:250px"></el-input>
        </div>
        <div class="flex flex-align-center gap-20">
          <div class="flex flex-align-center">
            <div class="font-label font-bold">达人状态：</div>
            <el-select v-model="state">
              <el-option v-for="(v,i) in stateList" :key="i" :value="v.value" :label="v.label"></el-option>
            </el-select>
          </div>
          <div class="flex flex-align-center">
            <div class="font-label font-bold">建联微信：</div>
            <el-select v-model="account" filterable>
              <el-option :value="null" label="全部"></el-option>
              <el-option v-for="(v,i) in accountList" :key="i" :value="v.KOLWeixinId" :label="v.WeiXinAccount"></el-option>
            </el-select>
          </div>
        </div>
        <div class="flex flex-align-center gap-20">
          <div class="flex flex-align-center">
            <div class="font-label font-bold">达人等级：</div>
            <el-select v-model="grade">
              <el-option v-for="(v,i) in gradeList" :key="i" :value="v.value" :label="v.label"></el-option>
            </el-select>
          </div>
          <div class="flex flex-align-center">
            <div class="font-label font-bold">带货分类：</div>
            <el-select v-model="classity" multiple>
              <el-option v-for="(v,i) in classityList" :key="i" :value="v.KOLTakeGoodsCategoryId" :label="v.CategoryName"></el-option>
            </el-select>
          </div>
          <div class="flex flex-align-center">
            <div class="font-label font-bold">头部达人：</div>
            <el-select v-model="isTop">
              <el-option v-for="(v,i) in isTopList" :key="i" :value="v.value" :label="v.label"></el-option>
            </el-select>
          </div>
          <div>
            <el-button type="primary" @click="search">查询</el-button>
          </div>
          <div>
            <el-button type="text" @click="reset">重置筛选条件</el-button>
          </div>
        </div>
      </div>
      <div style="margin-top:15px">
        <el-table :data="tablelist" v-loading="tableloading" ref="tablelist" row-key="Id">
          <el-table-column prop="" label="达人" fixed="left" min-width="220px">
            <template slot-scope="scope">
              <div>
                <div class="flex flex-align-center gap-5">
                  <div class="ellipsis">
                    <el-popover placement="top-start" trigger="hover">
                      <div style="max-width:300px">
                        {{scope.row.NickName}}
                      </div>
                      <div class="ellipsis color-409eff" slot="reference" style="cursor: pointer;" @click="toDetails(scope.row)">
                        {{scope.row.NickName}}
                      </div>
                    </el-popover>
                  </div>
                  <img :src="scope.row.KOLPlatformIconComplete" class="table-icon" alt="">
                    
                </div>
                <div class="color-999999">
                  {{scope.row.PlatformAccount}}
                </div>
                <div class="flex flex-align-center gap-10">
                  <el-tag size="mini" class="tag-toubu" v-if="scope.row.IsHead">头部</el-tag>
                  <el-tag size="mini" class="tag-level" v-if="scope.row.Level">
                    {{gradeList.find(v=>v.value==scope.row.Level).label}}
                  </el-tag>
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="" label="建联微信" width="120">
            <template slot-scope="scope">
              <div class="color-606266">
                {{scope.row.KOLWeixinIdName||'--'}}
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="StateValue" label="达人状态" width="150">
            <template slot-scope="scope">
              <div class="color-606266 flex flex-column gap-5">
                <div>{{scope.row.StateValue}}</div>
                <div v-if="scope.row.State==2" class="flex flex-align-center gap-10">
                  <el-tag effect="plain" size="small" style="cursor: pointer;" @click="toSendSample(scope.row)">寄样 ></el-tag>
                  <el-tag effect="plain" size="small" style="cursor: pointer;" type="danger" @click="setSendSample(scope.row,true)"
                   v-if="!scope.row.IsNotNeedSendSample">无需寄样 x</el-tag>
                </div>
                <div v-if="scope.row.State==3">
                  <el-tag effect="plain" size="small" style="cursor: pointer;" @click="toCreatCooperation(scope.row)">创建合作</el-tag>
                </div>
                <div v-if="scope.row.State==4">
                  <el-tag effect="plain" size="small" style="cursor: pointer;" @click="toCooperationPlan(scope.row)">跟进合作</el-tag>
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="" label="联系方式" width="150">
            <template slot-scope="scope">
              <div class="color-606266 flex flex-column gap-5">
                <div v-for="(v,i) in scope.row.ContactTypeShow" :key="i" v-if="i<2" class="flex flex-align-center gap-5 color-606266">
                  <img src="http://xsoss2016.oss-cn-hangzhou.aliyuncs.com/images/melyshop/zhannei-logo.png" v-if="v.type==1" class="table-icon" alt="">
                  <img src="http://xsoss2016.oss-cn-hangzhou.aliyuncs.com/images/melyshop/houtai-logo.png" v-if="v.type==2" class="table-icon" alt="">
                  <img src="http://xsoss2016.oss-cn-hangzhou.aliyuncs.com/images/melyshop/youxiang-logo.png" v-if="v.type==3" class="table-icon" alt="">
                  <img src="http://xsoss2016.oss-cn-hangzhou.aliyuncs.com/images/melyshop/qq-logo.png" v-if="v.type==4" class="table-icon" alt="">
                  <img src="http://xsoss2016.oss-cn-hangzhou.aliyuncs.com/images/melyshop/shouji-logo.png" v-if="v.type==5" class="table-icon" alt="">
                  <img src="http://xsoss2016.oss-cn-hangzhou.aliyuncs.com/images/melyshop/weixin-logo.png" v-if="v.type==6" class="table-icon" alt="">
                  <span>{{v.value}}</span>
                </div>
                <el-popover placement="bottom-start" trigger="hover" v-if="scope.row.ContactTypeShow&&scope.row.ContactTypeShow.length>3">
                  <div class="color-606266 flex flex-column gap-5">
                    <div v-for="(v,i) in scope.row.ContactTypeShow" :key="i" class="flex flex-align-center gap-5 color-606266" style="width:150px">
                    <img src="http://xsoss2016.oss-cn-hangzhou.aliyuncs.com/images/melyshop/zhannei-logo.png" v-if="v.type==1" class="table-icon" alt="">
                    <img src="http://xsoss2016.oss-cn-hangzhou.aliyuncs.com/images/melyshop/houtai-logo.png" v-if="v.type==2" class="table-icon" alt="">
                    <img src="http://xsoss2016.oss-cn-hangzhou.aliyuncs.com/images/melyshop/youxiang-logo.png" v-if="v.type==3" class="table-icon" alt="">
                    <img src="http://xsoss2016.oss-cn-hangzhou.aliyuncs.com/images/melyshop/qq-logo.png" v-if="v.type==4" class="table-icon" alt="">
                    <img src="http://xsoss2016.oss-cn-hangzhou.aliyuncs.com/images/melyshop/shouji-logo.png" v-if="v.type==5" class="table-icon" alt="">
                    <img src="http://xsoss2016.oss-cn-hangzhou.aliyuncs.com/images/melyshop/weixin-logo.png" v-if="v.type==6" class="table-icon" alt="">
                      <span>{{v.value}}</span>
                    </div>
                  </div>
                  <el-button type="text" slot="reference">
                    展开 <i class="el-icon-arrow-down"></i>
                  </el-button>
                </el-popover>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="" label="粉丝数量">
            <template slot-scope="scope">
              <div class="color-606266">
                <div v-if="scope.row.FansUnitCount">
                  {{scope.row.FansUnitCount}}{{scope.row.FansUnitValue}}
                </div>
                <div v-else>
                  --
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="" label="目标粉丝占比" width="120">
            <template slot-scope="scope">
              <div class="color-606266">
                {{scope.row.TargetFansRate?(scope.row.TargetFansRate+'%'):'--'}}
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="" label="客单均价">
            <template slot-scope="scope">
              <div class="color-606266">
                {{scope.row.CustomerUnitPrice?(scope.row.CustomerUnitPrice+'元'):'--'}}
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="" label="带货分类" min-width="150">
            <template slot-scope="scope">
              <div class="color-606266">
                <el-popover placement="top-start" trigger="hover" v-if="scope.row.KOLTakeGoodsCategoryDtos&&scope.row.KOLTakeGoodsCategoryDtos.length">
                  <div style="max-width:300px">
                    {{scope.row.KOLTakeGoodsCategoryDtos.map(v=>v.CategoryName).join('/')}}
                  </div>
                  <div slot="reference">
                    {{scope.row.KOLTakeGoodsCategoryDtos.map(v=>v.CategoryName).join('/')}}
                  </div>
                </el-popover>
                <div v-else>--</div>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="" label="寄样次数">
            <template slot-scope="scope">
              <div>
                <div v-if="scope.row.IsNotNeedSendSample">
                  <div class="color-606266">
                    无需寄样
                  </div>
                  <div v-if="scope.row.IsNotNeedSendSample">
                    <el-tag effect="plain" size="small" style="cursor: pointer;" @click="setSendSample(scope.row,false)">恢复寄样</el-tag>
                  </div>
                </div>
                <el-button type="text" v-else-if="scope.row.SendSampleCount" @click="toLookSendSample(scope.row)">{{scope.row.SendSampleCount}}次</el-button>
                <div v-else class="color-606266">
                  0次
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="" label="合作次数">
            <template slot-scope="scope">
              <div>
                <el-button type="text" v-if="scope.row.CooperateCount" @click="toCooperationPlan(scope.row)">{{scope.row.CooperateCount}}次</el-button>
                <div v-else class="color-606266">
                  0次
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="" label="系统回收次数" width="120">
            <template slot-scope="scope">
              <div class="color-606266">{{scope.row.RecoveryCount}}次</div>
            </template>
          </el-table-column>
          <el-table-column prop="" label="备注" min-width="200">
            <template slot-scope="scope">
              <div class="color-606266">
                <el-popover placement="top-start" trigger="hover" v-if="scope.row.Remark">
                  <div style="max-width:300px">
                    {{scope.row.Remark}}
                  </div>
                  <div class="ellipsis-two" slot="reference">
                    {{scope.row.Remark}}
                  </div>
                </el-popover>
                <div v-else>--</div>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="EmployeeBindTime" label="添加时间" width="170"></el-table-column>
          <el-table-column prop="" label="操作" fixed="right" width="250">
            <template slot-scope="scope">
              <div class="flex flex-align-center gap-10">
                <el-button type="text" @click="toDetails(scope.row)">详情</el-button>
                <div v-if="scope.row.State==1">
                  <el-button type="text" @click="toConnect(scope.row)">已建联</el-button>
                </div>
                <buttonPermissions datas="myExpertLiveVoid" v-if="![4,6].includes(scope.row.State)">
                  <el-button type="text" @click="toVoid(scope.row,true)">作废</el-button>
                </buttonPermissions>
                <buttonPermissions :datas="'myExpertLiveSendBack'" v-if="[1,2,3].includes(scope.row.State)">
                  <el-button type="text" @click="toSendBack(scope.row)">退回</el-button>
                </buttonPermissions>
                <buttonPermissions datas="myExpertLiveTransfer" v-if="scope.row.State!=6">
                  <el-button type="text" @click="toTransfer(scope.row,true)">转移</el-button>
                </buttonPermissions>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <div style="text-align:right;margin-top:10px" v-if="total">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="[10, 20, 30, 40]"
            :page-size="pagesize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total">
          </el-pagination>
        </div>
      </div>
    </el-card>

    <viod-dialog :show="showViod" :selectionList="selectionList" @close="showViod=false"
     @confirm="showViod=false,gettablelist()" :isSingle="isSingle"></viod-dialog>

    <transfer-dialog :show="showTransfer" :selectionList="selectionList" @close="showTransfer=false"
     @confirm="showTransfer=false,gettablelist()" :isSingle="isSingle"></transfer-dialog>
     
    <content-dialog :show="showConnect" :selectionList="selectionList" @close="showConnect=false"
     @confirm="showConnect=false,gettablelist()" :isSingle="isSingle"></content-dialog>

    <sendBack-dialog :show="showSendBack" :selectionList="selectionList" @close="showSendBack=false"
     @confirm="showSendBack=false,gettablelist()" :isSingle="isSingle"></sendBack-dialog>
  </div>
</template>

<script>
import buttonPermissions from '@/components/buttonPermissions';
import viodDialog from "../components/viod"
import transferDialog from "../components/transfer"
import contentDialog from "../components/content"
import sendBackDialog from "../components/sendBack"
import {
  kolMemberlist,
  kolMemberkolWeixinFilterList,
  kolTakeGoodsCategorylist,
  kolMemberreceive,
  kolMemberrestore,
  kolMembersetNeedSendSample,
  kolPlatformlist
} from "@/api/sv3.0.0"
import {
  employeelistbystate
} from "@/api/TurnTomySelf"
import {
  employeeloginEmployeeInfo
} from "@/api/login"
export default {
  components: {
    buttonPermissions,
    viodDialog,
    transferDialog,
    contentDialog,
    sendBackDialog,
  },
  computed: {
    allcheck(){
      if(!this.tablelist||!this.tablelist.length) return false
      return this.tablelist.every(v=>{
        return this.tableSelect.some(x=>x.Id==v.Id)
      })
    }
  },
  data () {
    return {
      activeName:'0',
      tabsList:[
        {KOLPlatformId:'0',PlatformName:'全部'},
      ],
      keywords:'',
      grade:null,
      gradeList:[
        {value:null,label:'全部'},
        {value:1,label:'S级'},
        {value:2,label:'A级'},
        {value:3,label:'B级'},
        {value:4,label:'C级'},
      ],
      classity:[],
      classityList:[],
      isTop:null,
      isTopList:[
        {value:null,label:'全部'},
        {value:true,label:'是'},
        {value:false,label:'否'},
      ],
      state:null,
      stateList:[
        {value:null,label:'全部'},
        {value:0,label:'待建联'},
        {value:1,label:'建联中'},
        {value:2,label:'已建联，待寄样'},
        {value:3,label:'已寄样/无需寄样，待合作'},
        {value:4,label:'合作中'},
        {value:5,label:'合作完成'},
        {value:6,label:'已作废'},
      ],
      connectList:[],
      account:null,
      accountList:[],
      tablelist:[],
      tableloading:false,
      currentPage:1,
      pagesize:10,
      total:0,
      selectionList:[],
      showViod:false,
      showTransfer:false,
      showConnect:false,
      showSendBack:false,
      isSingle:true,
      userInfo:{},
    }
  },
  async mounted () {
    await this.getUserInfo()
    this.getPlatform()
    this.getWXlist()
    this.getBusiness()
    this.getClassityList()
    this.gettablelist()
  },
  methods: {
    async getUserInfo(){
      try{
        let res = await employeeloginEmployeeInfo({})
        if(res.IsSuccess){
          this.userInfo = res.Result
        }
      }finally{
        //
      }
    },
    async getPlatform(){
      try{
        let res = await kolPlatformlist()
        if(res.IsSuccess){
          this.tabsList = this.tabsList.concat(res.Result.map(v=>{
            v.KOLPlatformId = v.KOLPlatformId+''
            return v
          }))
        }
      }finally{
        //
      }
    },
    toLookSendSample(row){
      this.$router.push({
        name:'sendSampleList',
        query:{
          PlatformAccount:row.PlatformAccount
        }
      })
    },
    toSendSample(row){
      this.$router.push({
        name:'sendSampleList',
        query:{
          Id:row.Id
        }
      })
    },
    toCreatCooperation(row){
      this.$router.push({
        name:'cooperationPlan',
        params:{
          Id:0,
          expertMsg:{
            Id:row.Id,
            NickName:row.NickName,
            PlatformAccount:row.PlatformAccount,
            KOLPlatformIconComplete:row.KOLPlatformIconComplete
          }
        }
      })
    },
    toCooperationPlan(row){
      this.$router.push({
        name:'cooperationPlan',
        params:{
          PlatformAccount:row.PlatformAccount
        }
      })
    },
    async setSendSample(row,IsRecover){
      try{
        let res = await kolMembersetNeedSendSample({
          Id:row.Id,
          IsNotNeedSendSample:row.IsNotNeedSendSample
        })
        if(res.IsSuccess){
          this.$message({
            showClose: true,
            message: `操作成功`,
            type: 'success'
          })
          this.gettablelist()
        }
      }finally{
        //
      }
    },
    toSendBack(row){
      this.selectionList = [row]
      this.showSendBack = true
    },
    toConnect(row){
      this.selectionList = [row]
      this.showConnect = true
    },
    async getClassityList(){
      try{
        let res = await kolTakeGoodsCategorylist()
        if(res.IsSuccess){
          this.classityList = res.Result
        }
      }finally{
        //
      }
    },
    async getBusiness(){
      try{
        let res = await employeelistbystate({
          EmployeeState:-1,
        })
        if(res.IsSuccess){
          this.connectList = res.Result
        }
      }finally{
        //
      }
    },
    async getWXlist(){
      try{
        let res = await kolMemberkolWeixinFilterList({
          Skip:0,
          Take:99999,
          EmployeeId:this.userInfo.EmployeeId
        })
        if(res.IsSuccess){
          this.accountList = res.Result.Results
        }
      }finally{
        //
      }
    },
    toDetails(row){
      this.$router.push({
        path:'/expertLive/expertLiveOpenSea/details',
        query:{
          Id:row.Id,
          
        }
      })
    },
    toTransfer(row,isSingle){
      if(isSingle){
        this.isSingle = true
        this.selectionList = [row]
      }else{
        this.isSingle = false
        this.selectionList = this.tableSelect
      }
      if(!this.selectionList||!this.selectionList.length){
        this.$message({
          showClose: true,
          message: `请选择达人`,
          type: 'error'
        })
        return
      }
      this.showTransfer = true
    },
    toVoid(row,isSingle){
      if(isSingle){
        this.isSingle = true
        this.selectionList = [row]
      }else{
        this.isSingle = false
        this.selectionList = this.tableSelect
      }
      if(!this.selectionList||!this.selectionList.length){
        this.$message({
          showClose: true,
          message: `请选择达人`,
          type: 'error'
        })
        return
      }
      this.showViod = true
    },
    async gettablelist(){
      try{
        this.tableloading = true
        let res = await kolMemberlist({
          Keywords:this.keywords,
          Level:this.grade,
          KOLTakeGoodsCategoryId:this.classity,
          IsHead:this.isTop,
          State:this.state,
          IsCurrentContact:this.type,
          KOLWeixinId:this.account,
          PageType:1,
          Skip:(this.currentPage-1)*this.pagesize,
          Take:this.pagesize,
          KOLPlatformId:this.activeName=='0'?null:this.activeName,
        })
        if(res.IsSuccess){
          this.tablelist = res.Result.Results.map(v=>{
            v.ContactTypeShow = v.ContactTypeValue.map((x,y)=>{
              return {
                type:v.ContactType[y],
                value:x,
                sort:v.ContactType[y]==1?2:1
              }
            })
            v.KOLMemberContactInformationDtos.map((x,y)=>{
              if(x.EMail){
                v.ContactTypeShow.push({
                  type:3,
                  value:x.EMail,
                  sort:3,
                })
              }
              if(x.QQ){
                v.ContactTypeShow.push({
                  type:4,
                  value:x.QQ,
                  sort:4,
                })
              }
              if(x.Phone){
                v.ContactTypeShow.push({
                  type:5,
                  value:x.Phone,
                  sort:5,
                })
              }
              if(x.WeixinAccount){
                v.ContactTypeShow.push({
                  type:6,
                  value:x.WeixinAccount,
                  sort:6,
                })
              }
            })
            v.ContactTypeShow.sort((a,b)=>{
              return b.sort-a.sort
            })
            return v
          })
          this.total = res.Result.Total
        }
      }finally{
        this.tableloading = false
      }
    },
    handleCurrentChange(e){
      this.currentPage = e
      this.gettablelist()
    },
    handleSizeChange(e){
      this.currentPage = 1
      this.pagesize = e
      this.gettablelist()
    },
    handleClick(e){
      this.handleCurrentChange(1)
    },
    reset(){
      this.keywords = ''
      this.grade = null
      this.classity = []
      this.isTop = null
      this.state = null
      this.type = null
      this.account = null
      this.search()
    },
    search(){
      this.handleCurrentChange(1)
    },
  }
}
</script>

<style lang='less' scoped>
.font-label{
  width:80px
}
.tag-toubu{
  background: rgba(245, 108, 108,.1);
  color: rgb(245, 108, 108);
  border: none;
  line-height: 20px;
}
.tag-level{
  background: rgba(230, 162, 60,.1);
  color: rgb(230, 162, 60);
  border: none;
  line-height: 20px;
}
.table-icon{
  width: 18px;
  height: 18px;
  border-radius: 2px;
}
/deep/.el-table__header{
  background: rgb(248,248,248)
}
/deep/.el-table__row{
  background: white;
}
</style>